export const AUTOMATIC_OEM_ENABLED_VEHICLES = {
  toyota: ['TOYOTA', 'LEXUS'],
};

export default {
  AUTOMATIC_OEM_ENABLED_VEHICLES,
};
